define("shared/components/shared/ui/search-box/result-blank", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--block u--p__tb__sm u--p__lr">
    <p class="u--text--light u--m__0">
      {{@message}}
    </p>
  </div>
  */
  {
    "id": "TWOdC0mb",
    "block": "[[[10,0],[14,0,\"o--block u--p__tb__sm u--p__lr\"],[12],[1,\"\\n  \"],[10,2],[14,0,\"u--text--light u--m__0\"],[12],[1,\"\\n    \"],[1,[30,1]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@message\"],false,[]]",
    "moduleName": "shared/components/shared/ui/search-box/result-blank.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});